/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const ChevronsChevronsLeft = ({ className }) => {
  return (
    <svg
      className={`chevrons-chevrons-left ${className}`}
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M16.7142 24.4286L10.2856 18L16.7142 11.5714M25.7142 24.4286L19.2856 18L25.7142 11.5714"
        stroke="#0F1217"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
